
export type ProjectBasicInfoVisibility = typeof ProjectBasicInfoVisibility[keyof typeof ProjectBasicInfoVisibility];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectBasicInfoVisibility = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE',
  LINK_ONLY: 'LINK_ONLY',
} as const;
